import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Coffee, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";
import { MugProgress, MugCountdown } from "@/components/merch/MugProgress";

export function MyMugOrder() {
  const [gifts, setGifts] = useState([]);
  useEffect(() => { api.get("/mug-gift").then(({ data }) => setGifts(data.gifts || [])).catch(() => {}); }, []);
  if (!gifts.length) return null;
  return (
    <section className="rounded-3xl bg-[#121212] text-white p-5 sm:p-6 ring-1 ring-amber-300/25 space-y-4" data-testid="my-mug-order">
      <div className="flex items-center gap-2 flex-wrap">
        <Coffee className="w-5 h-5 text-amber-300" />
        <h2 className="font-display text-lg font-black">Meine Dankeschön-Tasse</h2>
        <Link to="/dankeschoen-tasse" className="ml-auto text-xs font-bold text-amber-300 inline-flex items-center hover:underline" data-testid="my-mug-order-link">Details <ChevronRight className="w-3.5 h-3.5" /></Link>
      </div>
      {gifts.map((g) => (
        <div key={g.id} className="space-y-2">
          <p className="text-xs text-white/70">Status: <b className="text-amber-300" data-testid={`my-mug-status-${g.id}`}>{g.status_label}</b>{g.tracking ? <> · Sendungsnummer <span className="font-mono">{g.tracking}</span></> : ""}</p>
          <MugProgress g={g} dark />
          <MugCountdown g={g} dark />
        </div>
      ))}
    </section>
  );
}
